import EventList from '../views/EventList/EventList.vue'
import AddEvent from '../views/AddEvent/AddEvent.vue'
import CopyEvent from '../views/CopyEvent/CopyEvent.vue'
import CopyEventToRegions from '../views/CopyEventToRegions/CopyEventToRegions.vue'
import EditEvent from '../views/EditEvent/EditEvent.vue'
import ViewEvent from '../views/ViewEvent/ViewEvent.vue'
import AccessDenied from '../views/Error/AccessDenied.vue'
import GeneralError from '../views/Error/GeneralError.vue'
import _404 from '../views/Error/404.vue'
import TemporaryProblem from '../views/Error/TemporaryProblem.vue'

export default class RouteBuilder {
  /** @type {Store} */
  store

  /** @type {Connection} */
  apiConnection

  constructor (store, apiConnection) {
    this.store = store
    this.apiConnection = apiConnection
  }

  build () {
    return [
      {
        path: '/auth/:clientCode/:userId/:sessionKey',
        beforeEnter: (to, from, next) => {
          this.apiConnection.openSession(to.params.clientCode, to.params.sessionKey)
          this.store.commit('setUserId', parseInt(to.params.userId))
          this.store.commit('setClientCode', to.params.clientCode)

          next('/')
        }
      },
      {
        path: '/',
        name: 'Event list',
        component: EventList
      },
      {
        path: '/add-event',
        name: 'Add event',
        component: AddEvent
      },
      {
        path: '/copy-event/:id',
        name: 'Copy event',
        component: CopyEvent
      },
      {
        path: '/copy-event-to-regions/:id',
        name: 'Copy event to regions',
        component: CopyEventToRegions
      },
      {
        path: '/edit-event/:id',
        name: 'Edit event',
        component: EditEvent
      },
      {
        path: '/view-event/:id',
        name: 'View event',
        component: ViewEvent
      },
      {
        path: '/access-denied',
        component: AccessDenied
      },
      {
        path: '/temporary-problem',
        component: TemporaryProblem
      },
      {
        path: '/error',
        component: GeneralError
      },
      {
        path: '*',
        component: _404
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/RouteBuilder.js